import React, { FunctionComponent } from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import { css } from "@adjust/libs/emotion";

import type { Question } from "../types";

type QuestionProps = {
  question: Question;
};

const card = css({
  borderRadius: 16,
  border: "1px solid #dfe8f5",
  marginBottom: "1.5rem",
  transition: "all .2s ease",
});

const header = css({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",
  marginBottom: "1rem",
});

const icon = css({
  color: "#1f5fbf",
  fontSize: "1.3rem",
  flexShrink: 0,
});

const title = css({
  margin: 0,
  fontFamily: "Cormorant Garamond, serif",
  fontWeight: 700,
  fontSize: "1.8rem",
  color: "#1f355e",
});

const paragraph = css({
  fontSize: "1.05rem",
  lineHeight: 1.8,
  color: "#5f6b7a",

  "&:last-child": {
    marginBottom: 0,
  },
});

const QuestionComponent: FunctionComponent<QuestionProps> = ({ question }) => (
  <Card className={card}>
    <Card.Body className="p-4">
      <header className={header}>
        <FontAwesomeIcon icon={faCircleQuestion} className={icon} />

        <h2 className={title}>{question.question}</h2>
      </header>

      {question.answer.map((text, i) => (
        <p key={i} className={paragraph}>
          {text}
        </p>
      ))}
    </Card.Body>
  </Card>
);

export default React.memo(QuestionComponent);
